import { queryClient, apiRequest } from "../lib/queryClient";

const petPackageKey = "petPackage";

export function usePetPackages(options = {}) {
  const {
    filters = {},
    sort = { direction: "desc" },
    pagination = { page: 1, limit: 10 },
  } = options;

  const fetchPetPackage = async () => {
    const queryParams = new URLSearchParams();
    queryParams.append("page", pagination.page);
    queryParams.append("limit", pagination.limit);
    queryParams.append("sortField", sort.field);
    queryParams.append("sortDirection", sort.direction);
    for (const [key, value] of Object.entries(filters)) {
      queryParams.append(key, value);
    }
    if (filters.search) {
      queryParams.append("search", filters.search);
    }
    const response = await apiRequest(
      `/admin/pet-packages?${queryParams.toString()}`,
      {
        method: "GET",
      }
    );

    return response;
  };

  const createPetPackage = async (userData) => {
    const response = await apiRequest("/admin/pet-packages", {
      method: "POST",
      body: JSON.stringify(userData),
    });
    queryClient.invalidateQueries({ queryKey: [petPackageKey] });
    return response;
  };

  const updatePetPackage = async ({ id, userData }) => {
    const response = await apiRequest(`/admin/pet-packages/${id}`, {
      method: "PUT",
      body: JSON.stringify(userData),
    });
    queryClient.invalidateQueries({ queryKey: [petPackageKey] });
    return response;
  };

  const deletePetPackage = async (userId) => {
    await apiRequest(`/admin/pet-packages/${userId}`, {
      method: "DELETE",
    });
    queryClient.invalidateQueries({ queryKey: [petPackageKey] });
    return userId;
  };

  return {
    fetchPetPackage,
    createPetPackage,
    updatePetPackage,
    deletePetPackage,
  };
}
